// Logout.js
import React, { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../FireBase'; // Adjust the import based on your project structure

const Logout = ({ setUser }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = async () => {
      try {
        await signOut(auth); // Sign out the user
        setUser(null); // Reset the user state
        sessionStorage.removeItem('isLoggedIn');
        sessionStorage.removeItem('user');
        navigate('/login'); // Redirect to the login page
      } catch (error) {
        console.error('Logout failed:', error);
      }
    };

    handleLogout(); // Call the logout function when the component mounts
  }, [navigate, setUser]);

  return <div>Logging out...</div>; // Optionally, show a loading message
};

export default Logout;
